export const caseStudies = [
  {
    id: 'manufacturing-continuity',
    industry: 'Manufacturing',
    title: 'Restoring operational confidence after cascading disruption',
    before: 'Reactive insurance placement with limited visibility into critical dependencies.',
    problem: 'A multi-site manufacturer faced concurrent supply and operational shocks with unclear recovery priorities.',
    solution: 'AERA™ assessment, protection architecture redesign, and continuity activation pathways.',
    outcome: 'Faster recovery coordination and clearer board-level resilience visibility.',
    metrics: [
      { label: 'Downtime reduction', value: '38%' },
      { label: 'Coverage alignment', value: 'Improved' },
      { label: 'Maturity lift', value: '+2 levels' },
    ],
  },
  {
    id: 'healthcare-readiness',
    industry: 'Healthcare',
    title: 'Building workforce and operational resilience under pressure',
    before: 'Fragmented continuity plans and siloed risk conversations across clinical and admin teams.',
    problem: 'A regional health system needed enterprise readiness without disrupting care delivery.',
    solution: 'Integrated resilience diagnostics, workforce continuity design, and monitoring scorecards.',
    outcome: 'Unified crisis playbooks and measurable readiness across critical services.',
    metrics: [
      { label: 'Critical service coverage', value: '100%' },
      { label: 'Response time', value: 'Faster' },
      { label: 'Leadership clarity', value: 'High' },
    ],
  },
  {
    id: 'tech-cyber',
    industry: 'Technology',
    title: 'From cyber exposure to enterprise digital resilience',
    before: 'Cyber viewed as an IT issue; limited connection to continuity and protection architecture.',
    problem: 'A growth-stage technology firm needed board-ready cyber and digital risk posture.',
    solution: 'Digital risk assessment, cyber resilience architecture, and insurance as a strategic layer.',
    outcome: 'Executive confidence and a repeatable resilience operating rhythm.',
    metrics: [
      { label: 'Exposure visibility', value: 'Full' },
      { label: 'Incident readiness', value: 'Elevated' },
      { label: 'Program coherence', value: 'Unified' },
    ],
  },
];
